import Constants from './Constants';
import { Toast } from 'antd-mobile';
import CommonUtils from './CommonUtils';

const RESP_CODE = {
  sysError: '-1',
  logicError: '0',
  success: '1',
  noAuth: '1001',
  noLogin: '1002'
}

function doFetch(uri, handlers) {
  let url = Constants.API_BASE_URI + uri;
  !handlers&&(handlers={});

  fetch(url, {
    credentials: 'include',
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(checkStatus)
  .then(resolveJson)
  .then(checkErrorCode)
  .then((response) => handleSuccess(response, handlers.success, handlers.completed))
  .catch((error) => {
    handleError(error, handlers.logicError, handlers.sysError, handlers.completed);
  });
}

function doPost(uri, params, handlers) {
  let url = Constants.API_BASE_URI + uri;
  !handlers&&(handlers={});

  fetch(url, {
    credentials: 'include',
    method: 'post',
    headers: {
      'Content-type': 'application/json;charset=UTF-8'
    },
    body: JSON.stringify(params)
  })
  .then(checkStatus)
  .then(resolveJson)
  .then(checkErrorCode)
  .then((response) => handleSuccess(response, handlers.success, handlers.completed))
  .catch((error) => {
    handleError(error, handlers.logicError, handlers.sysError, handlers.completed);
  });
}

function doPut(uri, params, handlers) {
  let url = Constants.API_BASE_URI + uri;
  !handlers&&(handlers={});

  fetch(url, {
    credentials: 'include',
    method: 'put',
    headers: {
      'Content-type': 'application/json;charset=UTF-8'
    },
    body: JSON.stringify(params)
  })
  .then(checkStatus)
  .then(resolveJson)
  .then(checkErrorCode)
  .then((response) => handleSuccess(response, handlers.success, handlers.completed))
  .catch((error) => {
    handleError(error, handlers.logicError, handlers.sysError, handlers.completed);
  });
}

function doDelete(uri, handlers) {
  let url = Constants.API_BASE_URI + uri;
  !handlers&&(handlers={});

  fetch(url, {
    credentials: 'include',
    method: 'delete',
    headers: {
    }
  })
  .then(checkStatus)
  .then(resolveJson)
  .then(checkErrorCode)
  .then((response) => handleSuccess(response, handlers.success, handlers.completed))
  .catch((error) => {
    handleError(error, handlers.logicError, handlers.sysError, handlers.completed);
  });
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    let error = new Error();
    error.response = response;
    error.code = RESP_CODE.sysError;
    error.message = response.statusText;
    throw error;
  }
}

function resolveJson(response) {
  return response.json();
}

function checkErrorCode(data) {
  if (data.code !== undefined && data.code !== RESP_CODE.success) {
    let error = new Error();
    error.code = data.code;
    error.message = data.msg;
    throw error;
  }
  return data;
}

function handleSuccess(response, successHandler, completedHandler) {
  !successHandler&&(successHandler = defaultSuccessHandler);
  successHandler(response);
  completedHandler&&completedHandler();
}

function handleError(error, logicErrorHandler, sysErrorHandler, completedHandler) {
  !logicErrorHandler && (logicErrorHandler = defaultLogicErrorHandler);
  !sysErrorHandler && (sysErrorHandler = defaultSysErrorHandler);

  if (error.code === RESP_CODE.logicError) {
    logicErrorHandler(error);
  } else if (error.code === RESP_CODE.noLogin) {
    logicErrorHandler(error)
  } else if(error.code === RESP_CODE.noAuth) {
    logicErrorHandler(error)
  } else {
    sysErrorHandler(error);
  }
  completedHandler&&completedHandler();
}

function defaultSuccessHandler(response) {
  Toast.info(response&&response.message?response.message:Constants.Strings.REQ_SUCCESS);
}

function defaultLogicErrorHandler(error) {
  if(error.code === RESP_CODE.noAuth || error.code === RESP_CODE.noLogin) {
    return
  }
  Toast.fail(error&&error.message?error.message:Constants.Strings.SYS_BUSY_TIP, 2);
}

function defaultSysErrorHandler(error) {
  console.error(error)
  Toast.fail(Constants.Strings.SYS_BUSY_TIP, 2);
}


class DataFetcher {
  static distionary(dictType, handlers) {
    doFetch(`/common/dictionary?codes=${dictType}`, handlers)
  }

  static districtTree(handlers) {
    doFetch('/common/district/tree', handlers)
  }

  static bankList(handlers) {
    doFetch('/common/bank/list', handlers)
  }

  static jsapiAuth(successHandler) {
    doFetch('/wxmp/auth/jsapi', {success: successHandler});
  }

  static login(params, handlers) {
    doPost('/wxmp/auth/login', params, handlers);
  }

  static loginDevice(params={}, successHandler, completedHandler) {
    doPost('/wxmp/device/login', params, {success: successHandler, completed: completedHandler})
  }

  static profile(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/profile?${query}`, handlers);
  }

  static deviceInfo(deviceId, successHandler) {
    doFetch(`/wxmp/device/${deviceId}`, {success: successHandler})
  }

  static latestDevice(handlers) {
    doFetch('/wxmp/device/latest', handlers)
  }

  static rechargeRules(params, successHandler) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/balance/recharge_rules?${query}`, {success: successHandler})
  }

  static recharge(params, successHandler, completedHandler) {
    doPost('/wxmp/balance/recharge', params, {success: successHandler, completed: completedHandler});
  }

  static packetRules(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/balance/packet_rules?${query}`, handlers)
  }

  static couponPacketRules(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/balance/coupon_packet_rules?${query}`, handlers)
  }

  static buyPacket(params, successHandler, completedHandler) {
    doPost('/wxmp/balance/packet', params, {success: successHandler, completed: completedHandler});
  }

  static buyCouponPacket(params, handlers) {
    doPost('/wxmp/balance/coupon_packet', params, handlers);
  }

  static exchageBalance(params, handlers) {
    doPost('/wxmp/balance/exchange', params, handlers);
  }

  static orderDetail(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/public/order/detail?${query}`, handlers)
  }

  static deviceTypes(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/public/device_types?${query}`, handlers)
  }

  static userCouponSummary(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/coupon/user/summary?${query}`, handlers)
  }

  static grabCouponByCode(params, handlers) {
    doPost('/wxmp/coupon/user/grab_by_code', params, handlers)
  }

  static grabCouponByActivity(params, handlers) {
    doPost('/wxmp/coupon/user/grab_by_activity', params, handlers)
  }

  static grabCouponByTicket(params, handlers) {
    doPost('/wxmp/coupon/user/grab_by_ticket', params, handlers)
  }

  static exchangeCoupon(params, handlers) {
    doPost('/wxmp/coupon/user/exchange', params, handlers)
  }

  static userCoupons(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/coupon/user/page?${query}`, handlers)
  }

  static userCouponDetail(params, handlers) {
    doFetch(`/wxmp/coupon/user/detail?couponCode=${params.couponCode}`, handlers)
  }

  static userCouponActivity(params, handlers) {
    doFetch(`/wxmp/coupon/user/activity/${params.activityId}`, handlers)
  }

  static debugPay(params, successHandler, completedHandler) {
    doPost(`/wxmp/balance/debug_pay?orderNo=${params.orderNo}`, {}, {success: successHandler, completed: completedHandler});
  }

  static agentSites(successHandler) {
    doFetch('/agent/site/list', {success: successHandler})
  }

  static bindDevice(params, successHandler, completedHandler) {
    doPost('/agent/device/bind', params, {success: successHandler, completed: completedHandler})
  }

  static agentStatistic(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/statistic/agent?${query}`, handlers)
  }

  static siteStatistic(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/statistic/site?${query}`, handlers)
  }

  static deviceRevenue(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/statistic/device?${query}`, handlers)
  }
  
  static querySite(params, handlers) {
    doFetch(`/agent/site/page?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, handlers);
  }

  static createSite(params, handlers) {
    doPost('/agent/site', params, handlers)
  }

  static updateSite(params, handlers) {
    doPut('/agent/site', params, handlers)
  }

  static agentDevices(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/device/page?${query}`, handlers)
  }

  static updateDevice(params, handlers) {
    doPut('/agent/device', params, handlers)
  }

  static agentDeviceAlert(params, handlers) {
    doPost('/agent/device/alert', params, handlers)
  }

  static deviceStatistic(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/device/statistic?${query}`, handlers)
  }

  static deviceLogs(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/device/log?${query}`, handlers)
  }

  static agentPackets(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/packet/page?${query}`, handlers)
  }

  static updatePacket(params, handlers) {
    doPut('/agent/packet', params, handlers)
  }

  static createPacket(params, handlers) {
    doPost('/agent/packet', params, handlers)
  }

  static deletePacket(packetId, handlers) {
    doDelete(`/agent/packet/${packetId}`, handlers)
  }

  static agentOrders(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/order/page?${query}`, handlers)
  }

  static agentRefund(params, handlers) {
    doPost(`/agent/order/refund`, params, handlers)
  }

  static createGift(params, handlers) {
    doPost('/agent/gift', params, handlers)
  }

  static agentProfile(handlers) {
    doFetch('/agent/profile', handlers)
  }

  static updateBank(params, handlers) {
    doPut('/agent/profile/bank', params, handlers)
  }

  static updateAutoWithdraw(params, handlers) {
    doPut('/agent/profile/auto_withdraw', params, handlers)
  }

  static updateAgentProfile(params, handlers) {
    doPut('/agent/profile', params, handlers)
  }

  static agentWithdraw(params, handlers) {
    doPost('/agent/withdraw', params, handlers)
  }

  static withdrawRecords(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/withdraw/page?${query}`, handlers)
  }

  static logoutDevice(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doPost(`/agent/action/device/logout?${query}`, {}, handlers)
  }

  static restartDevice(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doPost(`/agent/action/device/restart?${query}`, {}, handlers)
  }

  static updateSiteShutdownTime(params, handlers) {
    doPut('/agent/site/shutdown_time', params, handlers)
  }

  static listTeamMember(handlers) {
    doFetch('/agent/team/member/list', handlers)
  }

  static pageTeamMember(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/team/member/page?${query}`, handlers)
  }

  static createTeamMember(params, handlers) {
    doPost('/agent/team/member', params, handlers)
  }

  static updateTeamMember(params, handlers) {
    doPut('/agent/team/member', params, handlers)
  }

  static unbindTeamMember(params, handlers) {
    doPut(`/agent/team/member/unbind/${params.id}`, {}, handlers)
  }

  static pageTeamSite(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/team/site/page?${query}`, handlers)
  }

  static pageDelegate(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/delegate/page?${query}`, handlers)
  }

  static createDelegate(params, handlers) {
    doPost(`/agent/delegate`, params, handlers)
  }

  static updateDelegate(params, handlers) {
    doPut(`/agent/delegate`, params, handlers)
  }

  static unbindDelegate(params, handlers) {
    doPut(`/agent/delegate/unbind/${params.id}`, {}, handlers)
  }

  static deleteDelegate(params, handlers) {
    doDelete(`/agent/delegate/${params.id}`, handlers)
  }

  static agentBills(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/bill/page?${query}`, handlers)
  }

  static agentActivities(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/coupon/activity/page?${query}`, handlers)
  }

  static agentActivity(activityId, handlers) {
    doFetch(`/agent/coupon/activity/${activityId}`, handlers)
  }

  static createActivity(params, handlers) {
    doPost('/agent/coupon/activity', params, handlers)
  }

  static updateActivity(params, handlers) {
    doPut('/agent/coupon/activity', params, handlers)
  }

  static couponCodes(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/coupon/codes?${query}`, handlers)
  }

  static updateActivityPermission(params, handlers) {
    doPut('/agent/coupon/permission', params, handlers)
  }

  static agentOrganizations(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/coupon/organization/page?${query}`, handlers)
  }

  static organizationDetail(params, handlers) {
    doFetch(`/agent/coupon/organization/${params.id}`, handlers)
  }

  static createOrganization(params, handlers) {
    doPost(`/agent/coupon/organization`, params, handlers)
  }

  static updateOrganization(params, handlers) {
    return doPut(`/agent/coupon/organization`, params, handlers)
  }

  static enableOrganization(params, handlers) {
    return doPut(`/agent/coupon/organization/enable/${params.id}`, {}, handlers)
  }

  static disableOrganization(params, handlers) {
    return doPut(`/agent/coupon/organization/disable/${params.id}`, {}, handlers)
  }

  static agentGrabbedCoupons(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/coupon/grabbed?${query}`, handlers)
  }

  static agentActivityDetail(params, handlers) {
    doFetch(`/agent/coupon/activity/${params.activityId}`, handlers)
  }

  static topOrganizations(params, handlers) {
    return doFetch('/agent/coupon/organization/top', handlers)
  }

  static pageCouponOperators(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/coupon/operator/page?${query}`, handlers)
  }

  static createCouponOperator(params, handlers) {
    doPost(`/agent/coupon/operator`, params, handlers)
  }

  static updateCouponOperator(params, handlers) {
    return doPut(`/agent/coupon/operator`, params, handlers)
  }

  static unbindCounponOperator(params, handlers) {
    return doPut(`/agent/coupon/operator/unbind/${params.id}`, {}, handlers)
  }

  static delegateAccounts(handlers) {
    doFetch(`/delegate/profile/list`, handlers)
  }

  static delegateProfile(params, handlers) {
    doFetch(`/delegate/profile/${params.id}`, handlers)
  }

  static delegateAgentStatistic(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/statistic/agent?${query}`, handlers)
  }

  static delegateSiteStatistic(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/statistic/site?${query}`, handlers)
  }

  static delegateDeviceRevenue(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/statistic/device?${query}`, handlers)
  }

  static delegateSites(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/site/list?${query}`, handlers)
  }

  static delegateSitePage(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/site/page?${query}`, handlers);
  }

  static delegateUpdateSite(params, handlers) {
    doPut('/delegate/site', params, handlers)
  }

  static delegateUpdateShutdownTime(params, handlers) {
    doPut('/delegate/site/shutdown_time', params, handlers)
  }

  static delegateOrders(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/order/page?${query}`, handlers)
  }

  static delegateRefund(params, handlers) {
    doPost(`/delegate/order/refund`, params, handlers)
  }

  static delegateGift(params, handlers) {
    doPost('/delegate/gift', params, handlers)
  }

  static delegateDevices(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/device/page?${query}`, handlers)
  }

  static delegateUpdateDevice(params, handlers) {
    doPut('/delegate/device', params, handlers)
  }

  static delegateDeviceStatistic(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/device/statistic?${query}`, handlers)
  }

  static delegateDeviceLogs(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/device/log?${query}`, handlers)
  }

  static delegateLogoutDevice(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doPost(`/delegate/action/device/logout?${query}`, {}, handlers)
  }

  static delegateRestartDevice(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doPost(`/delegate/action/device/restart?${query}`, {}, handlers)
  }

  static delegatePackets(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/delegate/packet/page?${query}`, handlers)
  }

  static delegateUpdatePacket(params, handlers) {
    doPut('/delegate/packet', params, handlers)
  }

  static delegateCreatePacket(params, handlers) {
    doPost('/delegate/packet', params, handlers)
  }

  static delegateDeletePacket(params, handlers) {
    doDelete(`/delegate/packet/${params.id}?delegateId=${params.delegateId}`, handlers)
  }

  static delegateBindDevice(params, successHandler, completedHandler) {
    doPost('/delegate/device/bind', params, {success: successHandler, completed: completedHandler})
  }

  static delegateDeviceAlert(params, handlers) {
    doPost('/delegate/device/alert', params, handlers)
  }

  static operatorOrganizations(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/coupon/operator/organizations?${query}`, handlers)
  }

  static operatorActivities(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/coupon/operator/activities?${query}`, handlers)
  }

  static operatorCouponTicket(params, handlers) {
    doPost('/wxmp/coupon/operator/ticket', params, handlers)
  }

  static operatorActivityDetail(params, handlers) {
    doFetch(`/wxmp/coupon/operator/activity/${params.activityId}`, handlers)
  }

  static operatorGrabbedCoupons(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/coupon/operator/grabbed?${query}`, handlers)
  }

  static rankGames(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/public/rank/games?${query}`, handlers)
  }

  static gameRank(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/public/rank?${query}`, handlers)
  }

  static brandInfo(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/public/brand?${query}`, handlers)
  }

  static kfProfile(handlers) {
    doFetch('/kf/profile', handlers)
  }

  static kfSearchOrder(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/kf/order?${query}`, handlers)
  }

  static kfRefund(params, handlers) {
    doPost(`/kf/order/refund`, params, handlers)
  }

  static kfGift(params, handlers) {
    doPost(`/kf/order/gift`, params, handlers)
  }

  static kfLogs(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/kf/operation_log/page?${query}`, handlers)
  }

  static virtualPlayer(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/wxmp/profile/virtual?${query}`, handlers)
  }

  static buyVirtualPacket(params, handlers) {
    doPost(`/wxmp/balance/virtual_packet`, params, handlers)
  }

  static agentGames(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/game/page?${query}`, handlers)
  }

  static enableGame(params, handlers) {
    return doPut(`/agent/game/enable/${params.id}`, {}, handlers)
  }

  static disableGame(params, handlers) {
    return doPut(`/agent/game/disable/${params.id}`, {}, handlers)
  }

  static createGame(params, handlers) {
    doPost('/agent/game', params, handlers)
  }

  static updateGame(params, handlers) {
    doPut('/agent/game', params, handlers)
  }

  static deleteGame(id, handlers) {
    doDelete(`/agent/game/${id}`, handlers)
  }

  static gameCategories(params, handlers) {
    let query = CommonUtils.generateQueryString(params)
    doFetch(`/agent/game/categories?${query}`, handlers)
  }
}

export default DataFetcher;


// WEBPACK FOOTER //
// ./src/utils/DataFetcher.js